import { render, staticRenderFns } from "./AppMensagem.vue?vue&type=template&id=742d6a1c&scoped=true&"
import script from "./AppMensagem.vue?vue&type=script&lang=js&"
export * from "./AppMensagem.vue?vue&type=script&lang=js&"
import style0 from "./AppMensagem.vue?vue&type=style&index=0&id=742d6a1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742d6a1c",
  null
  
)

export default component.exports